const buildInfo = {
	buildVersion: "1.4.0",
	buildDate: 1611751534805,
};

export default buildInfo;
